import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Subsection wrapper (Figma "List cell" title + grid of Info blocks + divider).
 * Flat / non-collapsible by design; for collapsible groups wrap this in the
 * existing lib-anc-form-section. The column count collapses automatically as the
 * host narrows (container query) so it fits the narrow right panel.
 */
@Component({
    selector: 'lib-anc-detail-section',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-detail-section.component.html',
    styleUrls: ['./anc-detail-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncDetailSectionComponent {
    /** Subsection heading (run through translate). Hidden when empty. */
    title = input<string>('');
    /** Info-block columns at full host width. */
    columns = input<number>(3);
    /** Render the bottom hairline divider. */
    divider = input<boolean>(true);
}
